import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {ReportsSharedModule} from "../reports/reports.shared.module";
import {BestWorstSellersReportCriteriaComponent} from "./reports/best-worst-sellers-report/best-worst-sellers-report-criteria/best-worst-sellers-report-criteria.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        ReportsSharedModule,
    ],
    declarations: [
        BestWorstSellersReportCriteriaComponent
    ],
    exports: [
        BestWorstSellersReportCriteriaComponent
    ]
})
export class SaleSharedModule {
}
